/* src/app/shared/components/rebrand-intro-splash/rebrand-intro-splash.component.css */
:host {
  position: fixed;
  inset: 0;
  z-index: 2600;
  display: block;
}
.ris-stage {
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 90px 24px 70px;
  overflow: hidden;
  background: var(--cf-chrome, #1d2530);
  font-family:
    "Inter Tight",
    -apple-system,
    sans-serif;
}
.ris-grid-tex {
  position: absolute;
  inset: 0;
  background-image: radial-gradient(rgba(255, 255, 255, .055) 1px, transparent 1.6px);
  background-size: 28px 28px;
  -webkit-mask-image:
    radial-gradient(
      70% 60% at 50% 42%,
      #000 0%,
      transparent 78%);
  mask-image:
    radial-gradient(
      70% 60% at 50% 42%,
      #000 0%,
      transparent 78%);
  pointer-events: none;
  z-index: 0;
}
.ris-glow {
  position: absolute;
  width: min(920px, 130vw);
  height: min(920px, 130vw);
  left: 50%;
  top: 40%;
  transform: translate(-50%, -50%);
  background:
    radial-gradient(
      circle,
      rgba(227, 253, 100, .20) 0%,
      rgba(227, 253, 100, .07) 38%,
      transparent 70%);
  pointer-events: none;
  z-index: 0;
}
@media (prefers-reduced-motion: no-preference) {
  .ris-glow {
    animation: ris-glow-pulse 7.5s ease-in-out infinite;
  }
}
@keyframes ris-glow-pulse {
  0%, 100% {
    opacity: .75;
    transform: translate(-50%, -50%) scale(1);
  }
  50% {
    opacity: 1;
    transform: translate(-50%, -50%) scale(1.07);
  }
}
.ris-skip {
  position: absolute;
  top: 22px;
  right: 26px;
  z-index: 5;
  appearance: none;
  border: none;
  cursor: pointer;
  background: transparent;
  font-family: inherit;
  font-size: 13px;
  font-weight: 500;
  color: rgba(255, 255, 255, .36);
  padding: 8px 10px;
  border-radius: 8px;
  transition: color .15s ease, background .15s ease;
}
.ris-skip:hover {
  color: rgba(255, 255, 255, .6);
  background: rgba(255, 255, 255, .06);
}
.ris-skip:focus-visible {
  outline: 2px solid var(--cf-brand);
  outline-offset: 2px;
  color: var(--cf-text-on-dark);
}
.ris-sweep {
  position: relative;
  z-index: 2;
  width: min(720px, 92vw);
  height: 120px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.ris-mark-slot {
  position: relative;
  width: 100%;
  height: 100%;
}
.ris-centered {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}
.ris-old {
  height: 52px;
  width: auto;
  display: block;
  opacity: 0;
}
@media (prefers-reduced-motion: no-preference) {
  .ris-old {
    animation: ris-old-in .6s cubic-bezier(.22, .7, .3, 1) .15s both, ris-old-out .55s cubic-bezier(.5, 0, .85, .4) 1.55s both;
  }
}
@keyframes ris-old-in {
  0% {
    opacity: 0;
    transform: scale(.94) translateY(8px);
  }
  100% {
    opacity: 1;
    transform: scale(1) translateY(0);
  }
}
@keyframes ris-old-out {
  0% {
    opacity: 1;
    transform: scale(1) translateY(0);
  }
  100% {
    opacity: 0;
    transform: scale(.9) translateY(-10px);
  }
}
.ris-band {
  position: absolute;
  top: 50%;
  width: 44%;
  height: 9px;
  border-radius: 999px;
  opacity: 0;
  z-index: 3;
}
.ris-band--left {
  left: 0;
  background:
    linear-gradient(
      90deg,
      rgba(227, 253, 100, 0) 0%,
      var(--cf-brand) 92%);
}
.ris-band--right {
  right: 0;
  background:
    linear-gradient(
      270deg,
      rgba(227, 253, 100, 0) 0%,
      var(--cf-brand) 92%);
}
@media (prefers-reduced-motion: no-preference) {
  .ris-band--left {
    animation: ris-band-left .78s cubic-bezier(.16, .84, .3, 1) 1.32s both;
  }
  .ris-band--right {
    animation: ris-band-right .78s cubic-bezier(.16, .84, .3, 1) 1.32s both;
  }
}
@keyframes ris-band-left {
  0% {
    opacity: 0;
    transform: translate(-135%, -50%);
  }
  16% {
    opacity: 1;
  }
  76% {
    opacity: 1;
    transform: translate(0%, -50%);
  }
  100% {
    opacity: 0;
    transform: translate(0%, -50%);
  }
}
@keyframes ris-band-right {
  0% {
    opacity: 0;
    transform: translate(135%, -50%);
  }
  16% {
    opacity: 1;
  }
  76% {
    opacity: 1;
    transform: translate(0%, -50%);
  }
  100% {
    opacity: 0;
    transform: translate(0%, -50%);
  }
}
.ris-flash {
  position: absolute;
  left: 50%;
  top: 50%;
  width: 170px;
  height: 170px;
  transform: translate(-50%, -50%) scale(.5);
  border-radius: 50%;
  background:
    radial-gradient(
      circle,
      rgba(255, 255, 255, .9) 0%,
      rgba(227, 253, 100, .55) 45%,
      transparent 72%);
  mix-blend-mode: screen;
  opacity: 0;
  z-index: 4;
  pointer-events: none;
}
@media (prefers-reduced-motion: no-preference) {
  .ris-flash {
    animation: ris-flash-pulse .42s ease-out 1.93s both;
  }
}
@keyframes ris-flash-pulse {
  0% {
    opacity: 0;
    transform: translate(-50%, -50%) scale(.5);
  }
  38% {
    opacity: .9;
    transform: translate(-50%, -50%) scale(1.25);
  }
  100% {
    opacity: 0;
    transform: translate(-50%, -50%) scale(1.8);
  }
}
.ris-lockup {
  display: flex;
  align-items: center;
  gap: 16px;
  opacity: 1;
}
.ris-icon-tile {
  width: 64px;
  height: 64px;
  display: block;
  overflow: visible;
}
.ris-tile-bg {
  fill: var(--cf-brand);
}
.ris-glyph-path {
  fill: transparent;
  stroke: var(--cf-chrome);
  stroke-width: 11;
  stroke-linecap: round;
  stroke-linejoin: round;
}
.ris-wordmark {
  font-family:
    "Bricolage Grotesque",
    "Inter Tight",
    sans-serif;
  font-weight: 800;
  font-size: clamp(30px, 4.4vw, 42px);
  letter-spacing: -.01em;
  color: var(--cf-text-on-dark, rgba(255,255,255,.94));
  line-height: 1;
}
@media (prefers-reduced-motion: no-preference) {
  .ris-icon-tile {
    animation: ris-tile-pop .5s cubic-bezier(.34, 1.56, .64, 1) 2.02s both;
  }
  .ris-wordmark {
    animation: ris-rise-in .6s ease 3.48s both;
  }
}
@keyframes ris-tile-pop {
  0% {
    opacity: 0;
    transform: scaleY(.08) scaleX(.55);
  }
  58% {
    opacity: 1;
    transform: scaleY(1.07) scaleX(1.03);
  }
  100% {
    opacity: 1;
    transform: scale(1);
  }
}
.ris-copy {
  position: relative;
  z-index: 2;
  margin-top: 34px;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  max-width: 520px;
}
.ris-headline {
  margin: 0;
  font-family:
    "Bricolage Grotesque",
    "Inter Tight",
    sans-serif;
  font-weight: 800;
  font-size: clamp(24px, 3.6vw, 34px);
  letter-spacing: -.01em;
  color: var(--cf-text-on-dark, rgba(255,255,255,.94));
  text-wrap: balance;
  opacity: 1;
}
.ris-subtitle {
  margin: 12px 0 0;
  font-size: clamp(14.5px, 1.6vw, 16px);
  line-height: 1.55;
  color: rgba(255, 255, 255, .6);
  text-wrap: balance;
  opacity: 1;
}
.ris-actions {
  margin-top: 28px;
  display: flex;
  align-items: center;
  gap: 18px;
  opacity: 1;
}
@media (prefers-reduced-motion: no-preference) {
  .ris-headline {
    animation: ris-rise-in .6s ease 4s both;
  }
  .ris-subtitle {
    animation: ris-rise-in .6s ease 4.35s both;
  }
  .ris-actions {
    animation: ris-rise-in .55s ease 4.78s both;
  }
}
@keyframes ris-rise-in {
  0% {
    opacity: 0;
    transform: translateY(14px);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
}
.ris-cta {
  appearance: none;
  border: none;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 9px;
  background: var(--cf-brand);
  color: var(--cf-chrome);
  font-family:
    "Inter Tight",
    -apple-system,
    sans-serif;
  font-weight: 600;
  font-size: 15px;
  padding: 13px 22px;
  border-radius: 999px;
  box-shadow: 0 8px 24px rgba(227, 253, 100, .18);
  transition:
    transform .15s ease,
    box-shadow .15s ease,
    background .15s ease;
}
.ris-cta:hover {
  background: #ecff8a;
  transform: translateY(-1px);
  box-shadow: 0 10px 28px rgba(227, 253, 100, .26);
}
.ris-cta:focus-visible {
  outline: 2px solid var(--cf-brand);
  outline-offset: 3px;
}
.ris-cta svg {
  width: 16px;
  height: 16px;
}
@media (max-width: 520px) {
  .ris-sweep {
    height: 96px;
  }
  .ris-icon-tile {
    width: 52px;
    height: 52px;
  }
  .ris-actions {
    flex-direction: column;
    gap: 12px;
  }
}
/*# sourceMappingURL=rebrand-intro-splash.component.css.map */
